export default __webpack_public_path__ + "static/media/V365MANB2.b666f48d.pdf";